var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-group',{attrs:{"label":"Title"}},[_c('b-input',{attrs:{"placeholder":"e.g Slik fungerer YouWish.no"},model:{value:(_vm.content.title),callback:function ($$v) {_vm.$set(_vm.content, "title", $$v)},expression:"content.title"}})],1),_c('img',{staticClass:"img-fluid",attrs:{"src":"/widgets/onetwothree.jpg"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }